import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'b3';
import { updateCallData, goToNextAction, openStackedStep } from '../logActivityReducer';
import ScheduleNextOrComplete from './ScheduleNextOrComplete';

var EvaluateClient = ({goToNextAction, openStackedStep, updateCallData}) => (
	<div className="wizardStepActions">
		<div className="header">
			<h2>Would we like them as a customer?</h2>
		</div>
		<div className="buttonsRow">
			<Button onClick={e => {
				updateCallData({callDeterminedClientAsGoodFit: true});
				goToNextAction(ScheduleNextOrComplete);
			}} type="success">Yes</Button>
			<Button onClick={e => {
				goToNextAction(ScheduleNextOrComplete);
			}} style={{marginLeft: 20, marginRight: 20}} type="warning">Still assessing</Button>
			<Button onClick={e => {
				openStackedStep('MarkAsDudStep');
			}} type="danger">No</Button>
		</div>
	</div>
);

export default connect(
	state => ({}),
	{ updateCallData, goToNextAction, openStackedStep }
)(EvaluateClient);



// WEBPACK FOOTER //
// ./app/components/schedule-wizard/actions/EvaluateClient.js